/*
* @Author: LiuMouLiang
* @Date:   2023-04-04 16:22:03
* @class:  基础方法
toJson
trace

*/
import {
    _paramsToString,
    _toJson,
    _for,
    _formatDate,
    _cloneObj,
    getObjVal,
    typeOf,
    asyncStateErrorMsg,
    getFileExtName,
    setUrlHttps,
    trace as _trace,
    warning as _warning,
    downloadFile as _downloadFile,
    downloadLink as _downloadLink,
} from 'tools';
import {
    IS_DEVELOPMENT,
    env_isTrace,
    BASE_API,
    KJ_PAGE_URL,
    ROUTE_URL_PC,
} from '_libs/host';
import {
    RESOUCEKEY,
} from '_libs/static';

export {
    asyncStateErrorMsg, //异步处理错误状态
};

export const formatDate = function(date, fmt){
    if(!date) return '--';
    return _formatDate(date, fmt);
};

const isVueComponent = obj => {
    return obj && (
        obj.$options && obj.$el
    );
};
/**
 * trace函数用于在特定环境下跟踪传入的参数，仅在开发环境下且env_isTrace标志为真时有效。
 * @param {...any} args - 可接受多个参数，用于在控制台中进行跟踪。
 */
export const trace = function(...args){
    if(IS_DEVELOPMENT && !env_isTrace) return false; //线上环境还是得有，sentry中没有报错输出
    let res = [];
    _for(args, el => {
        if(['array', 'object'].includes(typeOf(el))){
            if(isVueComponent && isVueComponent(el)){
                res.push(el);
            }else{
                res.push(_cloneObj(el));
            }
        }else{
            res.push(el);
        }
    })
    return _trace(...res);
};
// trace('环境 === ', process_env);

/**
 * 发出警告信息的函数。
 * 如果当前环境为发布模式（IS_RELEASE），或者传入的参数为空，或者环境不支持追踪（env_isTrace），则不会发出警告。
 * @param {...any} args - 可接受多个参数，这些参数将被传递给内部的警告处理函数 _warning。
 */
export const warning = function(...args){
    if(IS_DEVELOPMENT && !env_isTrace) return false;
    return _warning(...args);
};

export const toJson = function(data, def){
    if(typeOf(data) === 'string'){
        return _toJson(data) || def || [];
    };
    return data;
};


//old-页面没有登录不能使用route跳转
// 参考以前的跳转
export const jump = function(url, type) {
    if (url && ~url.indexOf('://')) {
        if(type==1){
            window.open(url, '_blank')
        }else{
            window.location.href = url;
        };
    }else{
        window.location.href = `${KJ_PAGE_URL}${ROUTE_URL_PC}#${url}`;
    };
};

export const $getH5Url = function(name, params = {}){
    if(!params.source) params.source = RESOUCEKEY;
    let url = `${BASE_API}/insurance-group-mobile/view/${name}.html${_paramsToString(params,'?')}`;
    return url;
};

export const jumpH5 = function(name, params = {}) {
    const url = $getH5Url(name, params);
    window.open(url, '_blank');
};

export const isImageType = function (file) {
    const imglist = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
    const tt = typeOf(file);
    let name = '';
    if(tt === 'file') {
        name = file.name;
    }else if(tt === 'string') {
        name = file;
    };
    if(!name) return false;
    const ext = getFileExtName(name) || '';
    return ext ? imglist.includes(ext) : false;
};

export const $setLinkUrl = function(url){
    if (!url) return '';
    url = setUrlHttps(url);
    return url;
};

export const downloadFile = function(url, name, apis={}) {
    url = $setLinkUrl(url);
    if(!url) return false;
    return _downloadFile(url, name, apis);
};

export const downloadLink = function(url, name, callback) {
    url = $setLinkUrl(url);
    if(!url) return false;
    return _downloadLink(url, name, callback);
};



// WEBPACK FOOTER //
// ./src/libs/util/base.js